export const baseUrl = "/v1/admin/citizens"

export const API_URL = {
    LIST: `${baseUrl}/meetings`,
}